import { useContext } from "react";
import { BookingSearchContext } from "../components/BookingSearchProvider";

export default function useBookingSearchContext() {
    return useContext(BookingSearchContext);
}
